import { withInstall } from '@xzx-design/utils'
import _List from './src/list'

export const List = withInstall(_List)
export default List

export * from './src/list'
